module.exports = __webpack_public_path__ + "static/phonoamp-3eba01faadda0857a0f478c9ee23e4c9.jpg";